module.exports = __webpack_public_path__ + "media/images/iconSocialShare__accent--dark-6dd04fa07c55b16e9ce1fb776b0536d3.png";